import type { Post } from '@/types'
import { getPostsByType } from '@/utils/endpoint'
import { useEffect, useState } from 'react'
import HomePageBlogList from './HomePageBlogList'

const HomePageBlogListWrapper = () => {
  const [tips, setTips] = useState<Post[]>([])
  const [promotions, setPromotions] = useState<Post[]>([])

  useEffect(() => {
    getPostsByType('tips').then(d => setTips(d || []))
    getPostsByType('promotion').then(d => setPromotions(d || []))
  }, [])

  return <HomePageBlogList tips={tips} promotions={promotions} />
}

export default HomePageBlogListWrapper
